import { useEffect, useState } from "react";
import SystemNotification, { SystemNotificationDisplayType } from "../../../Notifications/Models/SystemNotification";
import SystemNotificationBanner from "./SystemNotificationBanner";
import SystemNotificationModal from "./SystemNotificationModal";

interface SystemNotificationsProps {
    notifications: SystemNotification[]
    onNotificationAction : (notificationActionType : SystemNotificationButtonAction, notification: SystemNotification) => void;
    showModalNotifications : boolean;
    children: string | JSX.Element | JSX.Element[]    
}

export enum SystemNotificationButtonAction {
    CloseAction = 0,
    PrimaryAction = 1,
    DontRemindMeAction = 2
}

interface ModalVisibilityState {
    visibilityState : {[id: string]: boolean};
    visibleIndex: number;
    modalCount: number;
}

export default function SystemNotifications(props : SystemNotificationsProps) {
    const {notifications} = props;

    const bannerNotifications = notifications.filter(n => n.displayType == SystemNotificationDisplayType.Banner);
    const modalNotifications = notifications.filter(n => n.displayType == SystemNotificationDisplayType.Modal);
    const [modalVisbilityState, setModalVisbilityState] = useState<ModalVisibilityState>({ visibilityState: {}, visibleIndex: 0, modalCount: 0});

    useEffect(() => {
        if (modalVisbilityState.modalCount !== modalNotifications.length) {
            let newModalVisibilityState : ModalVisibilityState = {
                modalCount: modalNotifications.length,
                visibleIndex: 0,
                visibilityState: {}
            };

            if (modalNotifications.length > 0) newModalVisibilityState.visibilityState[modalNotifications[newModalVisibilityState.visibleIndex].systemNotificationId] = true;

            setModalVisbilityState(newModalVisibilityState)
        }


    }, [modalNotifications.length]);

    const onNotificationAction = async (notificationActionType : SystemNotificationButtonAction, notification: SystemNotification) => {
        props.onNotificationAction(notificationActionType, notification);

        if (notification.displayType == SystemNotificationDisplayType.Modal) {
            const currentVisibleModalIndex = modalVisbilityState.visibleIndex;
            let nextModalVisbilityState = {...modalVisbilityState};
            nextModalVisbilityState.visibilityState[modalNotifications[currentVisibleModalIndex].systemNotificationId] = false;

            if (modalVisbilityState.visibleIndex < modalNotifications.length - 1) {
                const nextVisibleModalIndex = 1 + currentVisibleModalIndex;
                nextModalVisbilityState.visibleIndex = nextVisibleModalIndex;

                nextModalVisbilityState.visibilityState[modalNotifications[nextVisibleModalIndex].systemNotificationId] = true;
            }

            setModalVisbilityState(nextModalVisbilityState);
        }

    }

    const modalNotificationElements = modalNotifications.map(notification => <SystemNotificationModal
        key={notification.systemNotificationId}
        notification={notification}
        showModal={props.showModalNotifications && notification.systemNotificationId in modalVisbilityState.visibilityState && modalVisbilityState.visibilityState[notification.systemNotificationId] == true}
        onNotificationAction={onNotificationAction}/>);

    const bannerNotificationElements = bannerNotifications.map(notification => <SystemNotificationBanner
        key={notification.systemNotificationId}
        notification={notification}
        onNotificationAction={onNotificationAction}/>);

    return (<div className="system-notifications">
        {props.children}
        {modalNotificationElements}
        {bannerNotificationElements}
    </div>);
}